



































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import _ from "lodash";
import { BudgetAllocation } from "@/modules/budget/BudgetAllocation";
import { User } from "front-component/modules/User";
import { Budget } from "@/modules/budget/Budget";
import {AllocationType} from "@/modules/budget/AllocationType";
import BudgetRepository from "@/repositories/budget/BudgetRepository";

export interface BudgetEdit {
    uuid?: string;
    label: string;
    beginDate: string;
    endDate: string;
    amount: number;
    amountIncludingTax: number;
    owner: {
        uuid: string;
    };
    consumedAmountAggregate: number;
    budgetAllocations: [{
        uuid?: string;
        label: string;
        allocationType: {
            uuid: string;
        };
    }];
}

const components = {

};

@Component({ components })

export default class AdminTabs extends Vue {
    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getCurrentUser") public user!: User;
    @Getter("getBudgets") public allBudgets!: Budget[];
    @Getter("getAllocationTypes") public allocationTypes!: AllocationType[];
    @Getter("getBudgetAllocationsByBudget") protected budgetAllocations!: (budgetUuid: string) => BudgetAllocation[];
    @Getter("getUserDepartment") public userDepartment!: string;
    @Action("loadBudgetAllocations") public loadBudgetAllocation: any;
    @Action("loadBudgets") public loadBudgets: any;
    @Action("loadAllocationTypes") public loadAllocationTypes: any;

    private budget: BudgetEdit | null = null;
    private budgetUuid: string = "";
    private budgetAllocationsAvailable: BudgetAllocation[] = [];
    private allocationUuid: string | null = null;
    private allocationEditing: boolean = false;
    private allocationTypeEdit: string = "";
    private newLine: boolean = false;
    private selectAllocationType: string = "";
    private newBudgetAllocationLabel: string = "";
    private deletionAvailable: boolean = false;

    @Watch("budgetUuid") public changeBudget(): void {
        this.newLine = false;

        if (this.budgetUuid === "") {
            return;
        }

        this.budget = _.cloneDeep(_.find(this.allBudgets, (budget: Budget) => {
            return budget.uuid === this.budgetUuid;
        }) as any as BudgetEdit);

        const collectionBudgetAllocations: any = [];

        this.budgetAllocationsAvailable = this.budgetAllocations(this.budgetUuid);
        _.forEach(this.budgetAllocationsAvailable, (bAllocAvail, key) => {
            collectionBudgetAllocations.push({
                uuid: bAllocAvail.uuid,
                label: bAllocAvail.label,
                allocationType: {
                    uuid: bAllocAvail.allocationType.uuid,
                }
            });
        });
        Vue.set(this.budget, "budgetAllocations", collectionBudgetAllocations);
    }

    private addBudget(): void {
        this.budgetUuid = "";
        this.budget = {
            label: "",
            beginDate: "",
            endDate: "",
            amount: 0.0,
            amountIncludingTax: 0.0,
            owner: {
                uuid: this.ownerUuid,
            },
            consumedAmountAggregate: 0,
        } as BudgetEdit;

        Vue.set(this.budget, "budgetAllocations", []);
    }

    private addAllocationType(): void {
        this.allocationEditing = true;
        this.allocationUuid = null;
    }

    private editAllocation(uuid: string): void {
        this.allocationUuid = uuid;
        this.allocationEditing = true;
        const allocationType = _.find(this.allocationTypes, (allocType) => {
            return allocType.uuid === uuid;
        });
        this.allocationTypeEdit = _.get(allocationType, "label", "");
    }

    private deleteLine(uuid: string): void {
        const collectionBudgetAllocations = _.filter(
            _.get(this.budget, "budgetAllocations"), (bAlloc: BudgetAllocation) =>
                bAlloc.uuid !== uuid
        );

        Vue.set(this.budget as BudgetEdit, "budgetAllocations", collectionBudgetAllocations);
    }

    private refreshBudgets(): void {
        this.budgetUuid = "";
        this.selectAllocationType = "";
        this.newBudgetAllocationLabel = "";
        this.loadBudgets();
        this.loadBudgetAllocation();
    }

    private saveBudget(): void {
        BudgetRepository.save(this.budget as BudgetEdit).then((data) => {
            this.refreshBudgets();
        });
        this.budget = null;
    }

    private addLineBudget(): void {
        this.selectAllocationType = "";
        this.newBudgetAllocationLabel = "";
        this.newLine = true;
    }

    private saveNewLineBudget(): void {
        if (!this.budget) {
            return;
        }

        this.budget.budgetAllocations.push({
            label: this.newBudgetAllocationLabel,
            allocationType: {
                uuid: this.selectAllocationType,
            },
        });
        this.newLine = false;
    }

    public get budgets(): Budget[] {
        return _.filter(this.allBudgets, (budget: Budget) => budget.owner.uuid === this.ownerUuid );
    }

    private get allocationTypesAvailable(): AllocationType[] {
        let allAllocationType = this.allocationTypes;

        if (this.budget) {
            _.forEach(this.budget.budgetAllocations, (bAlloc) => {
                allAllocationType = _.filter(allAllocationType, (allocType) => {
                    return allocType.uuid !== bAlloc.allocationType.uuid;
                });
            });

            return allAllocationType;
        }
        return [];
    }

    private get allowEdit(): string {
        return this.userDepartment;
    }
}
